import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";
import { t } from "@/i18n";
import { Capacitor } from "@capacitor/core";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Native app (iOS/Android): no cookie banner — consent is handled in onboarding
    if (Capacitor.isNativePlatform()) return;
    const consent = localStorage.getItem("ade_cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("ade_cookie_consent", JSON.stringify({ necessary: true, accepted_at: new Date().toISOString() }));
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem("ade_cookie_consent", JSON.stringify({ necessary: true, analytics: false, accepted_at: new Date().toISOString() }));
    setVisible(false);
  };

  useEffect(() => {
    document.body.classList.toggle("ade-cookie-open", visible);
    return () => document.body.classList.remove("ade-cookie-open");
  }, [visible]);

  if (!visible) return null;
  if (window.location.pathname.startsWith("/admin")) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[70] p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] bg-white border-t border-gray-200 shadow-2xl" data-testid="cookie-banner">
      <div className="max-w-lg mx-auto">
        <div className="flex items-start gap-3 mb-3">
          <Shield className="w-5 h-5 text-gray-600 mt-0.5 shrink-0" />
          <div>
            <p className="text-sm text-gray-700 font-medium mb-1">Cookie</p>
            <p className="text-xs text-gray-500">
              {t("cookieText")}
              <a href="/privacy" className="text-blue-500 ml-1">Privacy Policy</a>
            </p>
          </div>
        </div>
        <div className="flex gap-2">
          <Button onClick={accept} size="sm" className="flex-1 h-9 rounded-full bg-gray-900 text-white text-xs" data-testid="cookie-accept">
            {t("cookieAccept")}
          </Button>
          <Button onClick={reject} variant="outline" size="sm" className="flex-1 h-9 rounded-full text-xs" data-testid="cookie-reject">
            {t("cookieNecessary")}
          </Button>
        </div>
      </div>
    </div>
  );
}
